<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/cuti-list">Daftar Riwayat Cuti</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Pengaturan Cuti
        </li>
        <li class="breadcrumb-item">
          <a href="#/libur-list">Daftar Hari Libur</a>
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Pengaturan Cuti</h5>
    </div>

    <LogPopupTemplate ref="logPopup" />
    <DxPopup
      :visible="loadingVisible"
      title="Loading data..."
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </DxPopup>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="cutiSettingListStore.dataSourceCutiSettingList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          @editing-start="onEditingStart"
          @init-new-row="initNewRow($event)"
          @row-removing="onRowRemoving"
          @row-inserting="onInserting"
          @row-updating="onUpdating"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
          @editor-preparing="onEditorPreparing"
        >
          <!-- :filter-value="filterValue"
        :filter-sync-enabled="true" -->
          <!-- @selection-changed="onSelectionChanged" -->
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="can('absensi-update')"
            :allow-deleting="can('absensi-del')"
            :allow-adding="can('absensi-create')"
            :mode="dxEditingMode"
            v-bind="commonFunction.editingConfig(dxEditingMode, 'cutiSetting')"
          />
          <!--  -->

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <!-- cell-template="diff-cell-template" -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <!--  -->
          <DxColumn
            dataField="cuti_jenis_id"
            caption="Jenis Cuti"
            :allowHeaderFiltering="true"
            :allow-filtering="false"
            :allow-editing="can('absensi-update')"
            :header-filter="{
              dataSource: commonStore.getCutiJenisSource('crud').value,
            }"
          >
            <DxRequiredRule />
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="commonStore.cutiJenisStore"
            />
          </DxColumn>

          <DxColumn
            data-field="tgl"
            caption="Tgl Aktif"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
          >
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            data-field="jatah"
            caption="Jatah Cuti (Hari)"
            data-type="number"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
            :editor-options="{
              format: '#',
              inputAttr: { inputmode: 'numeric', pattern: '[0-9]*' },
            }"
          >
            <DxRequiredRule />
            <DxNumericRule :min="0" />
            <DxPatternRule
              :pattern="/^\d+$/"
              message="Hanya angka bulat positif yang diperbolehkan"
            />
          </DxColumn>

          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
          <DxColumn type="buttons" :width="110">
            <DxButtonDataGrid name="edit" />
            <DxButtonDataGrid name="delete" />
            <DxButtonDataGrid
              hint="View Log Perubahan"
              icon="clock"
              :visible="true"
              @click="this.$refs.logPopup.showBySubject($event, 'CutiSetting')"
            />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import { DxSelectBox } from "devextreme-vue/select-box";
import auth from "../auth";
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import { useCutiSettingListStore } from "@/stores/views/cuti-setting-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxRequiredRule,
  DxNumericRule,
  DxSelection,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

/* eslint-disable */
export default {
  components: {
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    DxRequiredRule,
    DxNumericRule,
    DxSelectBox,
    DxSelection,
    LogPopupTemplate,
    DxButtonDataGrid,
  },
  setup() {
    const cutiSettingListStore = useCutiSettingListStore();
    cutiSettingListStore.dataSourceCutiSettingList.filter(null);
    const commonStore = useCommonStore();

    return {
      cutiSettingListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const vm = this;
    return {
      dxEditingMode: "popup", //row
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      stylingMode: "filled",
      //outlined, filled, underlined
      labelMode: "floating",
      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
      selectedRows: [],
      loadingVisible: false,
      logPopupRef: null,
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    this.cutiSettingListStore.initialized;
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    onUpdating(e) {
      e.newData.updated_by_user_id = auth.getUser().id;
    },
    initNewRow(e) {
      e.data.created_by_user_id = auth.getUser().id;
    },

    can,

    refreshDatagrid(gridRef) {
      // this.cutiSettingListStore.dataSourceCutiSettingList.filter(null);
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Pengaturan Cuti");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pengaturan Cuti.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
